import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-user\">\n<style type=\"text/css\">\n\t#icon-user .st0{fill:rgba(55, 123, 255, 1);}\n</style>\n<path class=\"st0\" d=\"M42.9,40.8c0-0.4-0.1-0.7-0.2-1.1c-1.2-7-6.1-12.5-12.5-14.7c2.9-2,4.8-5.3,4.8-9.1c0-6.1-4.9-11-11-11\n\tS13,9.9,13,16c0,3.8,1.9,7.1,4.8,9.1c-6.4,2.2-11.3,7.7-12.5,14.7c-0.1,0.4-0.1,0.7-0.2,1.1c-0.1,0.8,0.5,1.6,1.3,1.7\n\tc0.1,0,0.1,0,0.2,0c0.8,0,1.4-0.6,1.5-1.3c0-0.3,0.1-0.6,0.1-0.9C9.6,32.6,16.2,27,24,27s14.4,5.6,15.8,13.2\n\tc0.1,0.3,0.1,0.6,0.1,0.9c0.1,0.8,0.8,1.4,1.7,1.3C42.4,42.4,43,41.6,42.9,40.8z M16,16c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8\n\tS16,20.4,16,16z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcons/svg/user.svg
// module id = ZYbq
// module chunks = 35